// extracted by mini-css-extract-plugin
export var appContainer = "Layout_appContainer__VkCBN";
export var footerWrapper = "Layout_footerWrapper__s1AlI";
export var md = "768px";
export var shared = "'../../shared.module.css'";